import { isMobileAtom, Styles, useRecoil } from '@orcar/common-d2c';
import { useState } from 'react';
import styled from 'styled-components';
import Carnival from '@/assets/img/carnival.png';
import K5 from '@/assets/img/K5 DL3.png';
import LongTermEstimationModal from './components/LongTermEstimationModal';
import LongTermVehicleCard from './components/LongTermVehicleCard';

const LONG_TERM_VEHICLE_LIST = [
  {
    tagList: [
      {
        text: '장기렌트',
      },
      {
        text: '2020년식',
      },
      {
        text: 'LPG',
      },
    ],
    imgUrl: K5,
    vehicleModelName: '2020년식 K5(LPG)',
    monthPrice: 650000,
  },
  {
    tagList: [
      {
        text: '장기렌트',
      },
      {
        text: '2015~18년식',
      },
      {
        text: '경유',
      },
    ],
    imgUrl: Carnival,
    vehicleModelName: '15~18년 올뉴그랜드카니발11인(경유)',
    monthPrice: 650000,
  },
];

type SelectedVehicleModel = {
  vehicleModelName: string;
  vehicleImgUrl: string;
  monthPrice: number;
};

const LongTermRentalSearchPage = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedVehicleModel, setSelectedVehicleModel] =
    useState<SelectedVehicleModel | null>(null);

  const handleClickCard = ({
    vehicleModelName,
    vehicleImgUrl,
    monthPrice,
  }: {
    vehicleModelName: string;
    vehicleImgUrl: string;
    monthPrice: number;
  }) => {
    setSelectedVehicleModel({
      vehicleModelName,
      vehicleImgUrl,
      monthPrice,
    });
    setIsOpenModal(true);
  };

  return (
    <PageWrapper isMobile={isMobile}>
      <Text
        font={isMobile ? Styles.NEW_FONT.H3 : Styles.NEW_FONT.H2}
        padding='0 0 40px 0'
      >
        청주 장기 렌트카
      </Text>
      <VehicleCardWrapper isMobile={isMobile}>
        {LONG_TERM_VEHICLE_LIST.map((vehicle, index) => (
          <LongTermVehicleCard
            key={index}
            tagList={vehicle.tagList}
            imgUrl={vehicle.imgUrl}
            vehicleModelName={vehicle.vehicleModelName}
            monthPrice={vehicle.monthPrice}
            onClick={() =>
              handleClickCard({
                vehicleModelName: vehicle.vehicleModelName,
                vehicleImgUrl: vehicle.imgUrl,
                monthPrice: vehicle.monthPrice,
              })
            }
          />
        ))}
      </VehicleCardWrapper>
      {isOpenModal && selectedVehicleModel && (
        <LongTermEstimationModal
          onClick={() => {
            setIsOpenModal(false);
            setSelectedVehicleModel(null);
          }}
          onClose={() => {
            setIsOpenModal(false);
            setSelectedVehicleModel(null);
          }}
          vehicleImgUrl={selectedVehicleModel.vehicleImgUrl}
          vehicleModelName={selectedVehicleModel.vehicleModelName}
          monthPrice={selectedVehicleModel.monthPrice}
        />
      )}
    </PageWrapper>
  );
};

export default LongTermRentalSearchPage;

const PageWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ isMobile }) => (isMobile ? '20px' : '0')};
`;

const VehicleCardWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: ${({ isMobile }) => (isMobile ? '32px' : '40px 30px')};
`;

const Text = styled.p<{
  font?: Record<string, string>;
  fontSize?: number;
  fontWeight?: number;
  color?: string;
  padding?: string;
}>`
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '16px')};
  font-weight: ${({ fontWeight }) => (fontWeight ? `${fontWeight}` : '400')};
  ${({ font }) => font && font};
  color: ${({ color, theme }) => color || theme.COLOR.GREY_01};
  padding: ${({ padding }) => padding || '0'};
`;
